import React from 'react'

import {
  EuiTitle,
  EuiSpacer,
  EuiFlexGroup,
  EuiFlexItem,
  EuiHorizontalRule,
} from '@elastic/eui'

import IntroCards from './IntroIndoorManualToC'

export default function IntroHome() {

  return (
    <React.Fragment>
      <EuiSpacer />
        <EuiTitle size="m">
            <h2>INSTAR IP Innenkameras - Handbücher</h2>
        </EuiTitle>
        <EuiTitle size="s">
            <h4>Indoor Überwachungskameras mit App, SD-Karte und Bewegungsmelder. 1080p Full HD und hochwertige IR-LEDs, sicher für Tag und Nacht.</h4>
        </EuiTitle>
        <EuiHorizontalRule margin="xs" />
      <EuiFlexGroup gutterSize="l" direction="column" style={{margin: '0 7px'}} >
        <EuiFlexItem>
          <IntroCards />
        </EuiFlexItem>
    </EuiFlexGroup>
  </React.Fragment>
  );
}